import { render, staticRenderFns } from "./VGauge.vue?vue&type=template&id=1a794a10&"
import script from "./VGauge.vue?vue&type=script&lang=js&"
export * from "./VGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports